export const mediaList = [
  {
    id: "tv-001",
    title: "流星追梦",
    type: "tv",
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    views: 3860,
    genres: ["都市", "励志", "爱情"],
    director: "陈嘉树",
    cast: ["林知夏", "周慕白", "苏晴", "许一诺"],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20TV%20drama%20poster%20with%20a%20young%20woman%20looking%20at%20a%20city%20skyline%20at%20sunset%2C%20cinematic%20deep%20blue%20and%20warm%20orange%20lighting%2C%20elegant%20minimal%20composition%2C%20moody%20atmosphere%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=xk-tv-001&orientation=portrait",
    summary:
      "小城女孩林知夏带着对舞台的渴望来到大都市，在一次次跌倒与重组中，她终于让自己的名字闪耀在聚光灯下。剧集以细腻的笔触描绘年轻人在梦想与现实之间的挣扎与成长。",
    episodes: 36,
  },
  {
    id: "tv-002",
    title: "长安夜行",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    views: 5210,
    genres: ["古装", "悬疑", "历史"],
    director: "顾长风",
    cast: ["陆离", "沈砚", "白鹿鸣", "崔行舟"],
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20at%20night%20with%20lanterns%20and%20misty%20palace%20rooftops%2C%20cinematic%20TV%20drama%20poster%2C%20deep%20indigo%20and%20amber%20glow%2C%20mysterious%20atmosphere%2C%20ornate%20details%2C%20high%20detail%20painting&width=600&height=900&seq=xk-tv-002&orientation=portrait",
    summary:
      "盛唐长安，一桩离奇命案牵出朝堂暗涌。司刑少卿沈砚与江湖游侠陆离结伴夜行，拨开层层迷雾，揭开一个足以撼动帝国根基的秘密。",
    episodes: 40,
  },
  {
    id: "tv-003",
    title: "都市晨光",
    type: "tv",
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    views: 2980,
    genres: ["都市", "职场", "群像"],
    director: "何未央",
    cast: ["程曦", "江野", "方圆", "邵一鸣"],
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20office%20tower%20at%20sunrise%20with%20young%20professionals%20walking%2C%20clean%20minimal%20TV%20drama%20poster%2C%20soft%20morning%20light%2C%20deep%20blue%20and%20orange%20accents%2C%20editorial%20photography%2C%20airy%20composition&width=600&height=900&seq=xk-tv-003&orientation=portrait",
    summary:
      "三组家庭、两代职场人，在同一栋写字楼里交织出关于奋斗、误解与理解的日常。晨光之下，每个人都在学着与生活和解。",
    episodes: 32,
  },
  {
    id: "tv-004",
    title: "星辰大海",
    type: "tv",
    region: "中国香港",
    year: 2023,
    rating: 7.9,
    views: 2140,
    genres: ["科幻", "冒险"],
    director: "郑海遥",
    cast: ["叶星宇", "罗楚", "黎见月"],
    cover:
      "https://readdy.ai/api/search-image?query=Astronaut%20silhouette%20against%20a%20vast%20starry%20galaxy%20with%20a%20distant%20blue%20planet%2C%20cinematic%20sci-fi%20series%20poster%2C%20deep%20space%20navy%20and%20warm%20glow%2C%20dramatic%20scale%2C%20high%20detail&width=600&height=900&seq=xk-tv-004&orientation=portrait",
    summary:
      "一支科研舰队的深空任务意外失控，船员们必须在资源枯竭前找到归途。浩瀚星河之下，人性的选择比宇宙更难以预测。",
    episodes: 24,
  },
  {
    id: "tv-005",
    title: "迷雾追凶",
    type: "tv",
    region: "韩国",
    year: 2024,
    rating: 9.1,
    views: 6180,
    genres: ["悬疑", "犯罪", "惊悚"],
    director: "金道允",
    cast: ["李准赫", "尹世罗", "朴敏书"],
    cover:
      "https://readdy.ai/api/search-image?query=Noir%20crime%20thriller%20poster%2C%20detective%20in%20a%20foggy%20alley%20with%20cold%20streetlights%2C%20cinematic%20dark%20teal%20and%20amber%20tones%2C%20tense%20moody%20atmosphere%2C%20high%20detail%20photography&width=600&height=900&seq=xk-tv-005&orientation=portrait",
    summary:
      "连环失踪案在雨夜重演，退休刑警被迫重返一线。真相如浓雾般难以穿透，而凶手也许一直站在最安全的位置。",
    episodes: 16,
  },
  {
    id: "tv-006",
    title: "梨落花开",
    type: "tv",
    region: "中国台湾",
    year: 2024,
    rating: 8.4,
    views: 3320,
    genres: ["爱情", "年代", "文艺"],
    director: "简亦恩",
    cast: ["许清梨", "方至远", "郑晓岚"],
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20period%20drama%20poster%2C%20blooming%20pear%20blossom%20trees%20in%20a%20traditional%20courtyard%2C%20soft%20warm%20afternoon%20light%2C%20dreamy%20neutral%20tones%20with%20deep%20blue%20sky%2C%20gentle%20nostalgic%20mood%2C%20high%20detail&width=600&height=900&seq=xk-tv-006&orientation=portrait",
    summary:
      "梨园盛景不再的年代，一位年轻的戏曲演员守着即将散场的戏班。当旧友归来，尘封多年的承诺在花落时节重新发芽。",
    episodes: 30,
  },
  {
    id: "tv-007",
    title: "边境线",
    type: "tv",
    region: "美国",
    year: 2023,
    rating: 8.0,
    views: 2760,
    genres: ["动作", "剧情", "西部"],
    director: "Derek Hale",
    cast: ["Marcus Vale", "Elena Rourke", "Jonah Pike"],
    cover:
      "https://readdy.ai/api/search-image?query=Western%20action%20drama%20poster%2C%20lone%20figure%20on%20a%20desert%20highway%20at%20dusk%2C%20vintage%20car%20and%20dust%2C%20cinematic%20amber%20and%20deep%20navy%20sky%2C%20gritty%20atmosphere%2C%20high%20detail%20photography&width=600&height=900&seq=xk-tv-007&orientation=portrait",
    summary:
      "边境小镇因一条走私路线陷入动荡，退役军人与当地警长被卷入一场无法回头的对峙。有些界线一旦跨越，就再也回不去。",
    episodes: 10,
  },
  {
    id: "movie-001",
    title: "星际回声",
    type: "movie",
    region: "中国大陆",
    year: 2025,
    rating: 8.8,
    views: 7420,
    genres: ["科幻", "冒险", "剧情"],
    director: "岑屿",
    cast: ["顾承", "夏迎", "韩川"],
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20facing%20a%20giant%20blue%20planet%20with%20swirling%20rings%2C%20deep%20navy%20space%20and%20warm%20amber%20rim%20light%2C%20cinematic%20scale%2C%20high%20detail%20render&width=600&height=900&seq=xk-movie-001&orientation=portrait",
    summary:
      "人类第一次接收到来自深空的规律信号。为了回应它，一支国际团队踏上了可能无法返航的旅程。当回声再次响起，人类终于读懂了自己的孤独。",
    duration: "156 分钟",
  },
  {
    id: "movie-002",
    title: "追风少年",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    views: 4630,
    genres: ["青春", "运动", "励志"],
    director: "方南舟",
    cast: ["陆然", "安小满", "何叙"],
    cover:
      "https://readdy.ai/api/search-image?query=Youth%20sports%20movie%20poster%2C%20teenagers%20cycling%20along%20a%20coastal%20road%20with%20sunlight%20flares%2C%20energetic%20warm%20and%20deep%20blue%20sky%2C%20dynamic%20motion%2C%20high%20detail%20photography&width=600&height=900&seq=xk-movie-002&orientation=portrait",
    summary:
      "小镇少年为了守住父亲留下的自行车行，加入了省队选拔。风里、雨里、赛道尽头，他追上的是梦想，也是与自己的和解。",
    duration: "118 分钟",
  },
  {
    id: "movie-003",
    title: "深海之光",
    type: "movie",
    region: "日本",
    year: 2023,
    rating: 8.7,
    views: 5540,
    genres: ["动画", "奇幻", "家庭"],
    director: "早见悠真",
    cast: ["声优 · 藤崎遥", "声优 · 大江真", "声优 · 森野望"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20fantasy%20film%20poster%2C%20child%20surrounded%20by%20glowing%20jellyfish%20in%20a%20deep%20blue%20ocean%2C%20magical%20warm%20light%20particles%2C%20dreamlike%20atmosphere%2C%20high%20detail%20illustration&width=600&height=900&seq=xk-movie-003&orientation=portrait",
    summary:
      "在海边小镇长大的女孩，遇见了一只会发光的深海生物。为了送它回家，她潜入连大人也不敢踏足的幽暗海域，也照亮了自己心底最柔软的地方。",
    duration: "108 分钟",
  },
  {
    id: "movie-004",
    title: "城市猎人",
    type: "movie",
    region: "中国香港",
    year: 2024,
    rating: 7.6,
    views: 3980,
    genres: ["动作", "犯罪", "喜剧"],
    director: "张柏川",
    cast: ["高健", "文咏芝", "司徒安"],
    cover:
      "https://readdy.ai/api/search-image?query=Action%20movie%20poster%2C%20stylish%20silhouette%20of%20a%20man%20on%20a%20neon-lit%20city%20rooftop%2C%20deep%20blue%20night%20with%20orange%20neon%20accents%2C%20cool%20cinematic%20mood%2C%20high%20detail%20photography&width=600&height=900&seq=xk-movie-004&orientation=portrait",
    summary:
      "顶级安保顾问接下一单看似普通的护送任务，却意外卷入一场横跨全城的阴谋。他能守护的，只剩下一个陌生人的秘密。",
    duration: "128 分钟",
  },
  {
    id: "movie-005",
    title: "时光信笺",
    type: "movie",
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    views: 4760,
    genres: ["爱情", "奇幻", "剧情"],
    director: "沈淮",
    cast: ["温以宁", "秦淮", "林晚"],
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%2C%20old%20wooden%20mailbox%20with%20glowing%20letters%20floating%2C%20warm%20golden%20light%20against%20deep%20blue%20evening%2C%20tender%20dreamy%20atmosphere%2C%20high%20detail&width=600&height=900&seq=xk-movie-005&orientation=portrait",
    summary:
      "一封写于二十年前的信，意外寄到了今天。两个被时间隔开的年轻人，通过信笺谈起了这场跨越岁月的恋爱。",
    duration: "132 分钟",
  },
  {
    id: "movie-006",
    title: "荒漠狂奔",
    type: "movie",
    region: "美国",
    year: 2024,
    rating: 7.8,
    views: 3620,
    genres: ["动作", "冒险", "事故"],
    director: "Nora Bennett",
    cast: ["Caleb Ford", "Riley Shaw", "Dina Cole"],
    cover:
      "https://readdy.ai/api/search-image?query=Action%20adventure%20movie%20poster%2C%20dusty%20sports%20car%20speeding%20across%20a%20vast%20desert%20plain%2C%20deep%20blue%20sky%20with%20orange%20sunset%20glow%2C%20kinetic%20energy%2C%20high%20detail%20photography&width=600&height=900&seq=xk-movie-006&orientation=portrait",
    summary:
      "为了救回被扣押的妹妹，一名普通司机被迫参加横穿荒漠的死亡拉力赛。引擎轰鸣之下，赌上的是整条性命。",
    duration: "114 分钟",
  },
  {
    id: "movie-007",
    title: "雨夜谜案",
    type: "movie",
    region: "韩国",
    year: 2023,
    rating: 8.5,
    views: 4890,
    genres: ["悬疑", "惊悚", "犯罪"],
    director: "崔在贤",
    cast: ["韩志勋", "徐恩彩", "柳正民"],
    cover:
      "https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%2C%20rain-soaked%20city%20street%20at%20night%20with%20a%20solitary%20umbrella%2C%20cold%20blue%20tones%20with%20a%20single%20amber%20lamp%2C%20tense%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=xk-movie-007&orientation=portrait",
    summary:
      "同一场雨夜，同一间公寓，二十年里发生了三起手法一致的命案。当第四场雨来临，真相终于无处躲藏。",
    duration: "122 分钟",
  },
  {
    id: "variety-001",
    title: "星光舞台",
    type: "variety",
    region: "中国大陆",
    year: 2025,
    rating: 8.7,
    views: 6890,
    genres: ["音乐", "竞演", "真人秀"],
    director: "总导演 · 苏原",
    cast: ["常驻 · 顾北", "常驻 · 温言", "常驻 · 罗一"],
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20variety%20show%20poster%2C%20glowing%20concert%20stage%20with%20spotlights%20and%20confetti%2C%20deep%20blue%20and%20warm%20orange%20stage%20lighting%2C%20energetic%20atmosphere%2C%20high%20detail&width=600&height=900&seq=xk-variety-001&orientation=portrait",
    summary:
      "来自各行各业的素人歌手同台竞演，用声音讲述自己的故事。每一期都是一次从平凡到闪耀的现场。",
    episodes: 12,
  },
  {
    id: "variety-002",
    title: "美食奇遇记",
    type: "variety",
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    views: 5120,
    genres: ["美食", "旅行", "纪实"],
    director: "总导演 · 何鹿",
    cast: ["常驻 · 阿禾", "常驻 · 陆小满"],
    cover:
      "https://readdy.ai/api/search-image?query=Food%20travel%20documentary%20poster%2C%20colorful%20local%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20golden%20light%20with%20deep%20blue%20evening%20background%2C%20appetizing%20high%20detail%20photography&width=600&height=900&seq=xk-variety-002&orientation=portrait",
    summary:
      "两位主持人走进中国的市井小巷，寻找被时间留下的味道。一碗面、一炉火，藏着最真实的人间烟火。",
    episodes: 20,
  },
  {
    id: "variety-003",
    title: "旅行者日记",
    type: "variety",
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    views: 4210,
    genres: ["旅行", "真人秀", "治愈"],
    director: "总导演 · 顾南",
    cast: ["常驻 · 沈川", "常驻 · 白晓", "常驻 · 林夏"],
    cover:
      "https://readdy.ai/api/search-image?query=Travel%20reality%20show%20poster%2C%20travelers%20on%20a%20mountain%20train%20overlooking%20misty%20valleys%2C%20deep%20blue%20dawn%20sky%20with%20warm%20sunrise%20glow%2C%20serene%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=xk-variety-003&orientation=portrait",
    summary:
      "三位旅行者用最慢的交通方式，走遍地图上那些被忽略的小城。镜头记录风景，也记录彼此的变化。",
    episodes: 16,
  },
  {
    id: "variety-004",
    title: "欢乐星期五",
    type: "variety",
    region: "中国大陆",
    year: 2024,
    rating: 7.7,
    views: 3890,
    genres: ["综艺", "游戏", "喜剧"],
    director: "总导演 · 明浩",
    cast: ["常驻 · 大熊", "常驻 · 小鹿", "常驻 · 阿吉"],
    cover:
      "https://readdy.ai/api/search-image?query=Fun%20game%20variety%20show%20poster%2C%20playful%20colorful%20studio%20set%20with%20balloons%20and%20lights%2C%20bright%20warm%20orange%20and%20deep%20blue%20palette%2C%20joyful%20energetic%20mood%2C%20high%20detail&width=600&height=900&seq=xk-variety-004&orientation=portrait",
    summary:
      "每期一个荒唐又认真的挑战，嘉宾们在爆笑里解锁隐藏技能。周五夜晚，卸下一周的疲惫一起大笑。",
    episodes: 24,
  },
  {
    id: "variety-005",
    title: "脑力大挑战",
    type: "variety",
    region: "韩国",
    year: 2025,
    rating: 8.6,
    views: 5460,
    genres: ["竞技", "推理", "真人秀"],
    director: "总导演 · 郑佑",
    cast: ["常驻 · 姜道", "常驻 · 申夏", "常驻 · 尹澈"],
    cover:
      "https://readdy.ai/api/search-image?query=Brain%20game%20show%20poster%2C%20players%20around%20a%20futuristic%20glowing%20table%20with%20puzzle%20symbols%2C%20deep%20blue%20tech%20lighting%20with%20orange%20highlights%2C%20tense%20strategic%20mood%2C%20high%20detail&width=600&height=900&seq=xk-variety-005&orientation=portrait",
    summary:
      "顶尖选手在封闭空间里展开智力与心理的博弈，每一轮淘汰都改写联盟与背叛。烧脑程度，前所未有。",
    episodes: 14,
  },
  {
    id: "variety-006",
    title: "音乐无界",
    type: "variety",
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    views: 4680,
    genres: ["音乐", "live", "合作"],
    director: "总导演 · 江雪",
    cast: ["常驻 · 苏黎", "常驻 · 阿肆", "常驻 · 木白"],
    cover:
      "https://readdy.ai/api/search-image?query=Live%20music%20show%20poster%2C%20band%20performing%20on%20a%20warm%20stage%20with%20hanging%20string%20lights%2C%20deep%20blue%20night%20and%20orange%20glow%2C%20intimate%20atmospheric%20mood%2C%20high%20detail&width=600&height=900&seq=xk-variety-006&orientation=portrait",
    summary:
      "不同风格的音乐人两两组队，把彼此的代表作改写成全新的样子。当边界被打破，音乐就有了无限可能。",
    episodes: 12,
  },
  {
    id: "variety-007",
    title: "城市探秘",
    type: "variety",
    region: "日本",
    year: 2024,
    rating: 7.9,
    views: 3240,
    genres: ["纪实", "文化", "旅行"],
    director: "总导演 · 佐藤亮",
    cast: ["常驻 · 铃木遥", "常驻 · 中村翔"],
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20exploration%20documentary%20poster%2C%20narrow%20old%20city%20alley%20with%20lanterns%20at%20dusk%2C%20deep%20blue%20evening%20and%20warm%20orange%20glow%2C%20quiet%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=xk-variety-007&orientation=portrait",
    summary:
      "两位主持人钻进城市的缝隙，探访老店、手艺人与即将消失的街区。在最熟悉的城市里，发现最陌生的故事。",
    episodes: 18,
  },
];